<template>
  <router-view/>
</template>

<style>
@import url("./assets/css/main.css");
@import url("./assets/css/fonts.css");
@import url("./assets/css/app.css");

</style>
